import {
  CreateOptionApiCall,
  DeleteApiCall,
  GetApiCall,
  ListApiCall,
  ListFieldsApiCall,
  ListFieldsOptionsApiCall,
  PostApiCall,
  PutApiCall,
} from "@/app/api/types";
import { Entity } from "@/app/fields/types";
import { createContext, useContext } from "react";

export interface IApiContext<T extends Entity> {
  listData: ListApiCall<T>;
  getData: GetApiCall<T>;
  getFields: ListFieldsApiCall<T>;
  updateEntry: PutApiCall<T>;
  deleteEntry?: DeleteApiCall;
  getFieldOptions: ListFieldsOptionsApiCall;
  createEntry?: PostApiCall<T>;
  createFieldOption: CreateOptionApiCall;
}

export const ApiContext = createContext<IApiContext<any>>({} as any);

export const useApiContext = () => useContext(ApiContext);
